import React, { useEffect, useState, useMemo } from "react";
import { viewApprovalLine } from "../../api/approval";
import { getDocSignatureInfo } from "../../api/papers";

export default function SignTableDocSingle({
  dns,
  onlyLastApprover = false,
  showEmptyBox = false,
  labels = [], // ✅ [추가] 커스텀 라벨 배열 (예: ["시공사", "PM"])
}) {
  const [creator, setCreator] = useState(null);
  const [lines, setLines] = useState([]);

  useEffect(() => {
    if (!dns) return;

    const load = async () => {
      try {
        // 작성자 정보 조회
        const sig = await getDocSignatureInfo(dns);
        setCreator(sig.data || null);

        // 결재 라인 조회
        const res = await viewApprovalLine(dns);
        setLines(res.data?.approval_lines || []);
      } catch (err) {
        console.error("Signature fetch error:", err);
      }
    };

    load();
  }, [dns]);

  /* ===============================
     승인자 계산
  =============================== */
  const approvers = useMemo(() => {
    const list = [...lines]
      .filter((l) => (showEmptyBox ? true : l.is_approved === "approved"))
      .sort((a, b) => a.order - b.order);

    if (onlyLastApprover && list.length > 1) {
      return [list[list.length - 1]];
    }

    return list;
  }, [lines, onlyLastApprover, showEmptyBox]);

  /* ===============================
     셀 구성 (라벨 적용 로직 수정)
  =============================== */
  const cells = useMemo(() => {
    const result = [];

    // 1. 작성자 (시공사)
    result.push({
      // ✅ labels[0]이 있으면 사용, 없으면 "작성자"
      label: labels[0] || "작성자",
      name: creator?.name || "-",
      sign: creator?.sign || null,
      state: "approved",
    });

    // 2. 승인자들 (PM 등)
    approvers.forEach((ap, idx) => {
      result.push({
        // ✅ labels[idx + 1]이 있으면 사용, 없으면 "승인자"
        label:
          labels[idx + 1] ||
          (approvers.length > 1 && !onlyLastApprover
            ? `승인자 ${idx + 1}`
            : "승인자"),
        name: ap.approver_name || "-",
        sign: ap.sign_file || null,
        state: ap.is_approved,
      });
    });

    return result;
  }, [creator, approvers, onlyLastApprover, labels]);

  if (!cells.length) return null;

  const isSingleCell = cells.length === 1;

  function renderSignatureRow(c) {
    return (
      <div className="relative h-full flex items-center justify-center">
        {" "}
        {/* 중앙 정렬 보정 */}
        <span
          style={{
            fontSize: "11px",
            position: "absolute",
            left: "6px",
            top: "50%",
            transform: "translateY(-50%)",
            whiteSpace: "nowrap",
          }}
        >
          {c.name}
        </span>
        {/* 승인 완료일 때만 서명 이미지 표시 */}
        {c.sign && c.state === "approved" && (
          <img
            src={c.sign}
            alt="sign"
            style={{
              height: "40px", // 높이 조정 (테이블 깨짐 방지)
              maxWidth: "60px",
              objectFit: "contain",
            }}
          />
        )}
      </div>
    );
  }

  return (
    <div className="flex justify-end w-full">
      <table
        className={`border mt-4 text-[12px] text-center border-black ${
          isSingleCell ? "" : "w-full"
        }`}
        style={{
          tableLayout: "fixed",
          width: isSingleCell ? "120px" : undefined,
        }}
      >
        <thead>
          <tr className="bg-gray-100">
            {cells.map((c, i) => (
              <th
                key={i}
                className="border border-black h-[28px]"
                style={{ width: isSingleCell ? "120px" : undefined }}
              >
                {c.label}
              </th>
            ))}
          </tr>
        </thead>

        <tbody>
          <tr>
            {cells.map((c, i) => (
              <td
                key={i}
                className="border border-black relative h-[50px]"
                style={{ width: isSingleCell ? "120px" : undefined }}
              >
                {renderSignatureRow(c)}
              </td>
            ))}
          </tr>
        </tbody>
      </table>
    </div>
  );
}
